<template>
  <base-table :data="history">
    <el-table-column
      prop="date"
      :label="$t('sections.alarms.fields.historyTable.date')"
      width="200%"
    />
    <el-table-column
      prop="user"
      :label="$t('sections.alarms.fields.historyTable.user')"
      width="200%"
    />
    <el-table-column
      prop="status"
      :label="$t('sections.alarms.fields.historyTable.newStatus')"
      width="110%"
    />
    <el-table-column
      prop="notes"
      :label="$t('sections.alarms.fields.historyTable.notes')"
    />
  </base-table>
</template>
<script>
export default {
  name: 'AlarmDetailHistoryTable',
  props: {
    history: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" scoped></style>
